import axios from 'axios';
import CONFIG from '../config';

export const getShowroom = () => axios.get(`${CONFIG.CDN_BASE}${CONFIG.SHOWROOM_PATH}/data.json?v=${CONFIG.VERSION}`).then(res => res.data);
